import Backdrop from '@material-ui/core/Backdrop';

// Material UI's Modal traps focus, makes the page behind inert, locks its
// scrolling and returns focus to the opener. PIN prompts and alerts open as
// later modals on top.
export const PRODUCT_OVERLAY_PROPS = {
  className: 'product-overlay',
  BackdropComponent: Backdrop,
  BackdropProps: { className: 'product-overlay-backdrop' },
};
